export default "__VITE_ASSET__DTpuKpHU__"